module.exports = __webpack_public_path__ + "static/media/frizo-instagram-share.fd81f11e.png";